export const BILLING_PERIOD_FORM_VALIDATION_RULES = {
    billingPeriodId: {
        isRequiredTrim: {
            value: true,
        },
    }     
};


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/BillingPeriodFormValidationRules.js